import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('./views/Info.vue')
    },
    
    {
      path: '/disease',
      name: 'disease',
      component: () => import('./views/disease.vue')
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('./views/Order.vue')
    },
  
    {
      path: '/Monoidal',
      name: 'Monoidal',
      component: () => import('./views/Monoidal.vue')
    },
    {
      path: '/YBLogin',
      name: 'YBLogin',
      component: () => import('./views/YBLogin.vue')
    },
    {
      path: '/YBMember',
      name: 'YBMember',
      component: () => import('./views/YBMember.vue')
    },
    {
      path: '/YBAdd',
      name: 'YBAdd',
      component: () => import('./views/YBAdd.vue')
    },
    {
      path: '/YBquery',
      name: 'YBquery',
      component: () => import('./views/YBquery.vue')
    },{
      path: '/YBBkstep1',
      name: 'YBBkstep1',
      component: () => import('./views/YBBkstep1.vue')
    },
     {
      path: '/TDMember',
      name: 'TDMember',
      component: () => import('./views/TDMember.vue')
    },
    {
      path: '/TDAdd',
      name: 'TDAdd',
      component: () => import('./views/TDAdd.vue')
    },
    {
      path: '/YBMessage',
      name: 'YBMessage',
      component: () => import('./views/YBMessage.vue')
    },
    
    
  ]
})
